import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, message,Spin } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  LogoutOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import Cookies from "js-cookie";
import { Country, State, City } from "country-state-city";
import axios from "axios";
import { ChromePicker } from "react-color";
import Dragger from "antd/es/upload/Dragger";

const { Option } = Select;

const NgoForm = () => {
  const [form] = Form.useForm();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [charityData, setCharityData] = useState({
    regno: "",
    name: "",
    websiteUrl: "",
    state: "",
    town:"",
    address: "",
    address_line_2:"",
    postcode: "",
    country: "",
    email: "",
    description: "",
    social_links: {
      facebook: "",
      instagram: "",
      youtube: "",
      twitter: "",
    },
    logo: "",
  });
  const [logoUrl, setLogoUrl] = useState("");
  const [color, setColor] = useState("#ffffff");
  const [loading, setLoading] = useState(false);
  const [logoLoading, setLogoLoading] = useState(false);
  

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCountries = () => {
      const countryData = Country.getAllCountries();
      setCountries(countryData);
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      const countryObj = countries.find(
        (item) => item.name === selectedCountry
      );
      const isoCode = countryObj.isoCode;

      const stateData = State.getStatesOfCountry(isoCode);

      setStates(stateData);
      setCities([]); // Reset cities when country changes
    } else {
      setStates([]);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedState) {
      const stateObj = states.find((item) => item.name === selectedState);
      const stateIsoCode = stateObj.isoCode;
      const countryCode = stateObj.countryCode;
      const cityData = City.getCitiesOfState(countryCode, stateIsoCode);
      setCities(cityData);
    } else {
      setCities([]);
    }
  }, [selectedState, selectedCountry]);

  const signOut = () => {
    Cookies.remove("jwtToken");
    navigate("/");
  };

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    form.setFieldsValue({ state: "", city: "" });
  };

  const handleStateChange = (value) => {
    setSelectedState(value);
    form.setFieldsValue({ city: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name in charityData.social_links) {
      setCharityData((prevData) => ({
        ...prevData,
        social_links: {
          ...prevData.social_links,
          [name]: value,
        },
      }));
    } else {
      setCharityData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleLogoUpload = async (file) => {
    setLogoLoading(true)
    const token = Cookies.get("jwtToken");
    console.log(token)
    const filename = file.name;

    try {
      const uploadResponse = await axios.post(
        `${import.meta.env.VITE_API_URL}/upload/open_file_upload`,
        { filename },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Upload logo: ",uploadResponse)

      const { url, key } = uploadResponse.data;

      const s3UploadResponse = await fetch(url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (s3UploadResponse.ok) {
        setCharityData((prevData) => ({
          ...prevData,
          logo: key,
        }));
        setLogoUrl(URL.createObjectURL(file));
        return false;
      } else {
        setLogoLoading(false)
        throw new Error("Failed to upload file to S3");

      }
    } catch (error) {
      console.error("Error uploading logo:", error.message);
      message.error("Error uploading logo. Please try again.");
    setLogoLoading(false)

      return false;
    }
  };

  const handleSubmit = async () => {
    if (!charityData.logo) {
      message.error("Please upload a logo.");
      return;
    }

    if (!color) {
      message.error("Please select a theme color.");
      return;
    }

    setLoading(true);
    const payload = {
      name: charityData.name,
      regno: charityData.regno,
      address: {
        address_line_1: charityData.address,
        address_line_2: charityData.address_line_2,
        postcode:charityData.postcode,
        town: "Nil",
        state: selectedState,
        country: selectedCountry,
        street_name: "Nil",
      },
      social_links: charityData.social_links,
      themes: {
        primary: color,
      },
      email: charityData.email,
      website: charityData.websiteUrl,
      description: charityData.description,
      logo: charityData.logo,
    };

    try {
      const token = Cookies.get("jwtToken");
      console.log("payload:",payload);
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/charity/onboarding`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      message.success("Form submitted successfully!");
      Cookies.set("jwtToken", response.data.access_token);
      navigate("/onboarding/ngodocuments");
    } catch (error) {
      message.error("Error submitting form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-wrap lg:flex-nowrap">
      <div
        className="lg:h-screen h-1/2 lg:w-3/5 lg:absolute bg-cover bg-center lg:block"
        style={{
          backgroundImage:
            'url("https://d1irs7zslorh1g.cloudfront.net/assets/slider/hands-cupping-heart-love-modified.jpg")',
        }}
      ></div>
      <div className="h-[95vh] lg:relative lg:z-10 lg:ml-[770px] w-full lg:w-2/5 mt-4  bg-white border rounded-[20px] -ml-1 overflow-auto">
        <div className="sticky top-0 z-10 flex justify-between items-center bg-white p-10 w-auto shadow-md">
          <Button
            className="flex items-center text-gray-600"
            onClick={() => navigate(-1)}
          >
            <ArrowLeftOutlined /> Back
          </Button>
          <Button className="flex items-center text-gray-600" onClick={signOut}>
            <LogoutOutlined /> Logout
          </Button>
        </div>

        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          initialValues={{ country: "", state: "", city: "" }}
          className="space-y-4 mt-8 p-4 "
        >
          <h2
            className="text-3xl text-center mb-8"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Charity Form
          </h2>
          <div className="flex flex-wrap -mx-2">
            <div className="w-full md:w-1/2 p-2">
              <Form.Item
                label="Charity Registration No."
                name="regno"
                rules={[
                  {
                    required: true,
                    message: "Please input your registration number!",
                  },
                ]}
              >
                <Input
                  name="regno"
                  value={charityData.regno}
                  onChange={handleChange}
                  className="border rounded-xl p-2 w-full"
                />
              </Form.Item>
            </div>
            <div className="w-full md:w-1/2 p-2">
              <Form.Item
                label="Organization Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input your organization name!",
                  },
                ]}
              >
                <Input
                  name="name"
                  value={charityData.name}
                  onChange={handleChange}
                  className="border rounded-xl p-2 w-full"
                />
              </Form.Item>
            </div>
          </div>
          <div className="p-2">
            <Form.Item
              label="Website URL"
              name="websiteUrl"
              rules={[
                { required: true, message: "Please input your website URL!" },
              ]}
            >
              <Input
                name="websiteUrl"
                value={charityData.websiteUrl}
                onChange={handleChange}
                className="border rounded-xl p-2 w-full"
              />
            </Form.Item>
          </div>
          <div className="p-2">
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input
                name="email"
                value={charityData.email}
                onChange={handleChange}
                className="border rounded-xl p-2 w-full"
              />
            </Form.Item>
          </div>
          <div className="p-2">
            <Form.Item
              label="Address"
              name="address"
              rules={[
                { required: true, message: "Please input your address!" },
              ]}
            >
              <Input
                name="address"
                value={charityData.address}
                onChange={handleChange}
                className="border rounded-xl p-2 w-full"
              />
            </Form.Item>
            </div>
            <div className="p-2">
            <Form.Item
              label="Address Line 2"
              name="address_line_2"
              rules={[
                { required: true, message: "Please input your address!" },
              ]}
            >
              <Input
                name="address_line_2"
                className="border rounded-xl p-2 w-full"
                onChange={handleChange}
              />
            </Form.Item>
            </div>
            <div className="p-2">
            <Form.Item
              label="Postcode"
              name="postcode"
              rules={[
                { required: true, message: "Please input your passcode!" },
              ]}
            >
              <Input
                name="postcode"
                type="number"
                onChange={handleChange}
                className="border rounded-xl p-2 w-full"
              />
            </Form.Item>
            </div>
          
          <div className="flex justify-center gap-4  ">
            <div className="p-1">
              <Form.Item
                label="Country"
                name="country"
                rules={[
                  { required: true, message: "Please select your country!" },
                ]}
              >
                <Select
                  onChange={handleCountryChange}
                  className="w-full border rounded-xl"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                  placeholder="Select Country"
                >
                  <Option value="">Select Country</Option>
                  {countries.map((country) => (
                    <Option key={country.isoCode} value={country.name}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="p-1">
              <Form.Item
                label="State"
                name="state"
                rules={[
                  { required: true, message: "Please select your state!" },
                ]}
              >
                <Select
                  onChange={handleStateChange}
                  className="w-full border rounded-xl"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                  placeholder="Select State"
                >
                  <Option value="">Select State</Option>
                  {states.map((state) => (
                    <Option key={state.isoCode} value={state.name}>
                      {state.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="p-1">
              <Form.Item
                onChange={handleChange}
                label="City"
                name="town"
                rules={[
                  { required: true, message: "Please select your city!" },
                ]}
              >
                <Select
                  className="w-full border rounded-xl"
                  name="town"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                  placeholder="Select City"
                >
                  <Option value="">Select City</Option>
                  {cities.map((city) => (
                    <Option key={city.name} value={city.name}>
                      {city.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className="p-2">
            <Form.Item
              label="Charity Description"
              name="description"
              rules={[
                { required: true, message: "Please input a description!" },
              ]}
            >
              <Input.TextArea
                name="description"
                value={charityData.description}
                onChange={handleChange}
                rows={4}
                className="border rounded-xl p-2 w-full"
              />
            </Form.Item>
          </div>

          <div className="p-2">
            <Form.Item label="Logo">
              <Dragger
                beforeUpload={handleLogoUpload}
                accept="image/*"
                showUploadList={false}
              >
                {logoUrl ? (
                  <img src={logoUrl} alt="logo" className="w-32 h-32 rounded-full mx-auto" />
                ) : (
                  <InboxOutlined className="text-gray-600" />
                )}
              </Dragger>
            </Form.Item>
          </div>

          <div className="p-2">
            <Form.Item label="Select Theme Color">
              <ChromePicker
                color={color}
                onChangeComplete={(color) => setColor(color.hex)}
              />
            </Form.Item>
          </div>

          <div className="p-2 flex justify-center">
            <Button
              type="primary"
              htmlType="submit"
              className="rounded-full w-48"
              loading={loading}
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NgoForm;
